import React, { useState } from 'react';
import {
  HeaderContainer,
  Logo,
  Nav,
  Button,
  HamburgerIcon,
  MobileMenu,
  Overlay,
  CloseButton,
  NavLinkStyled,
} from './styled';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoImg from '../../../assets/Logo.png'

const NavLinks: React.FC = () => {
  const location = useLocation();
  return <>
    <NavLinkStyled to="/" isActive={location.pathname === "/"}>Home</NavLinkStyled>
    <NavLinkStyled to="/about" isActive={location.pathname === "/about"}>About</NavLinkStyled>
    <NavLinkStyled to="/products" isActive={location.pathname === "/products"}>Products</NavLinkStyled>
  </>
};

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate()

  const handleButtonClick = () => {
    setMenuOpen(false);
    navigate('/?scroll=contact');
  }

  return (
    <>
      <HeaderContainer id="header">
        <Logo src={LogoImg} alt="Logo" />

        <Nav>
          <NavLinks />
            <Button onClick={handleButtonClick}>Get in Touch</Button>
        </Nav>

        <HamburgerIcon onClick={() => setMenuOpen(true)}>☰</HamburgerIcon>
      </HeaderContainer>

      {menuOpen && (
        <>
          <Overlay onClick={() => setMenuOpen(false)} />
          <MobileMenu>
            <CloseButton onClick={() => setMenuOpen(false)}>×</CloseButton>
            <NavLinks />
            <Button onClick={handleButtonClick}>Get in Touch</Button>
          </MobileMenu>
        </>
      )}
    </>
  );
};

export default Header;
